import { useRef, useEffect, useMemo } from 'react';
import * as THREE from 'three';
interface UseInstancedSlipsheetsProps {
	scene: THREE.Object3D | null;
	slipSheetMatrices: THREE.Matrix4[];
	cardboardMaterial: THREE.MeshStandardMaterial;
}

export function useInstancedSlipsheets({
	scene,
	slipSheetMatrices,
	cardboardMaterial,
}: UseInstancedSlipsheetsProps) {
	const instancedSlipsheetsRef = useRef<THREE.InstancedMesh | null>(null);

	const geometry = useMemo(() => new THREE.BoxGeometry(1, 1, 1), []);
	useEffect(() => {
		if (!scene) return;
		const mat = cardboardMaterial
		const instancedSlipsheets = new THREE.InstancedMesh(
			geometry,
			mat,
			slipSheetMatrices.length
		);
		instancedSlipsheets.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

		scene.add(instancedSlipsheets);
		instancedSlipsheetsRef.current = instancedSlipsheets;

		return () => {
			scene.remove(instancedSlipsheets);
			instancedSlipsheets.geometry?.dispose();
		};
	}, [scene, slipSheetMatrices.length]);

	useEffect(() => {
		if (!instancedSlipsheetsRef.current) return;
		const instanced = instancedSlipsheetsRef.current;

		instanced.count = slipSheetMatrices.length;
		slipSheetMatrices.forEach((matrix, i) => {
			instanced.setMatrixAt(i, matrix);
		});
		instanced.instanceMatrix.needsUpdate = true;
	}, [scene, slipSheetMatrices]);

	return {
		instancedSlipsheetsRef,
	};
}
